var _defs, _path, _ellipse, _g, _g2, _path2, _path3, _ellipse2, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _circle, _path16, _path17, _path18, _path19, _path20, _path21, _g3, _circle2, _circle3, _circle4, _circle5, _path22, _path23, _circle6, _circle7, _circle8, _circle9, _path24, _path25, _path26, _polygon, _polygon2, _circle10, _circle11, _path27, _circle12, _circle13, _path28, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShippingsProcessing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b469a9e0-5433-4729-b694-038fdc7b8087",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1144,
    height: 651.26,
    viewBox: "0 0 1144 651.26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a2db50a1-d77e-4212-a847-6fb1a49f9674",
    x1: 905.83,
    y1: 758.77,
    x2: 905.83,
    y2: 275.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logistics") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1172,554.94a180.56,180.56,0,0,1-26.12,93.88c0,34.62-16.14,66-42.32,88.87A144.74,144.74,0,0,1,1082.48,753c-.3.19-.61.37-.92.55-.56.33-1.12.66-1.69,1l-.53.31h0a164.61,164.61,0,0,1-81.08,20.82H245.17c-51.93,0-98.94-18.08-133-47.3S57.12,658.72,57.12,614.12A180.5,180.5,0,0,1,28,515.45c0-99.14,79.24-179.51,177-179.51,3.46,0,6.89.12,10.3.31C276.64,231.65,415,158.71,575.74,158.71c98.82,0,189.15,27.55,258.34,73.07A174.18,174.18,0,0,1,920,209.23c97.74,0,177,80.37,177,179.51a184.9,184.9,0,0,1-1,18.78A180,180,0,0,1,1172,554.94Z",
    transform: "translate(-28 -124.37)",
    fill: "#ff9100",
    opacity: 0.1
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 413,
    cy: 476.76,
    rx: 392,
    ry: 10.5,
    fill: "#ff9100",
    opacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("rect", {
    x: 142,
    y: 399.26,
    width: 125,
    height: 69,
    fill: "#65617d"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 411.26,
    width: 38,
    height: 8,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.75,
    y: 412.26,
    width: 28.5,
    height: 6,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269,
    y: 399.26,
    width: 125,
    height: 69,
    fill: "#65617d"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313,
    y: 411.26,
    width: 38,
    height: 8,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 317.75,
    y: 412.26,
    width: 28.5,
    height: 6,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142,
    y: 328.26,
    width: 125,
    height: 69,
    fill: "#65617d"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 340.26,
    width: 38,
    height: 8,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.75,
    y: 341.26,
    width: 28.5,
    height: 6,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269,
    y: 328.26,
    width: 125,
    height: 69,
    fill: "#65617d"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313,
    y: 340.26,
    width: 38,
    height: 8,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 317.75,
    y: 341.26,
    width: 28.5,
    height: 6,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142,
    y: 256.26,
    width: 125,
    height: 69,
    fill: "#65617d"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 268.26,
    width: 38,
    height: 8,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.75,
    y: 269.26,
    width: 28.5,
    height: 6,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269,
    y: 256.26,
    width: 125,
    height: 69,
    fill: "#65617d"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313,
    y: 268.26,
    width: 38,
    height: 8,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 317.75,
    y: 269.26,
    width: 28.5,
    height: 6,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269,
    y: 184.26,
    width: 125,
    height: 69,
    fill: "#65617d"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313,
    y: 196.26,
    width: 38,
    height: 8,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 317.75,
    y: 197.26,
    width: 28.5,
    height: 6,
    opacity: 0.1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("rect", {
    x: 396,
    y: 398.26,
    width: 125,
    height: 69,
    fill: "#65617d"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440,
    y: 410.26,
    width: 38,
    height: 8,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 444.75,
    y: 411.26,
    width: 28.5,
    height: 6,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 523,
    y: 398.26,
    width: 125,
    height: 69,
    fill: "#65617d"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 567,
    y: 410.26,
    width: 38,
    height: 8,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 571.75,
    y: 411.26,
    width: 28.5,
    height: 6,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396,
    y: 327.26,
    width: 125,
    height: 69,
    fill: "#65617d"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440,
    y: 339.26,
    width: 38,
    height: 8,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 444.75,
    y: 340.26,
    width: 28.5,
    height: 6,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 523,
    y: 327.26,
    width: 125,
    height: 69,
    fill: "#65617d"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 567,
    y: 339.26,
    width: 38,
    height: 8,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 571.75,
    y: 340.26,
    width: 28.5,
    height: 6,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396,
    y: 255.26,
    width: 125,
    height: 69,
    fill: "#65617d"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440,
    y: 267.26,
    width: 38,
    height: 8,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 444.75,
    y: 268.26,
    width: 28.5,
    height: 6,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 523,
    y: 255.26,
    width: 125,
    height: 69,
    fill: "#65617d"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 567,
    y: 267.26,
    width: 38,
    height: 8,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 571.75,
    y: 268.26,
    width: 28.5,
    height: 6,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 523,
    y: 183.26,
    width: 125,
    height: 69,
    fill: "#65617d"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 567,
    y: 195.26,
    width: 38,
    height: 8,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 571.75,
    y: 196.26,
    width: 28.5,
    height: 6,
    opacity: 0.1
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M906.29,124.48S822.1,119.4,832,178.4c0,0-2,10.43,7.48,15.16,0,0,.15-4.37,8.64-2.88a39.5,39.5,0,0,0,9.15.44,19.06,19.06,0,0,0,11.18-4.62h0s23.67-9.78,32.87-48.46c0,0,6.81-8.44,6.54-10.61l-14.21,6.07s4.86,10.25,1,18.77c0,0-.46-18.4-3.19-18-.55.09-7.38,3.55-7.38,3.55s8.35,17.85,2.05,30.83c0,0,2.39-22-4.66-29.54l-10,5.84s9.76,18.44,3.14,33.49c0,0,1.7-23.08-5.25-32.07l-9.06,7.07s9.17,18.18,3.58,30.66c0,0-.73-26.87-5.54-28.9,0,0-7.93,7-9.14,9.86,0,0,6.28,13.2,2.38,20.16,0,0-2.39-17.9-4.35-18,0,0-7.9,11.86-8.72,20,0,0,.34-12.1,6.81-21.13,0,0-7.64,1.31-12.1,6.27,0,0,1.23-8.39,14.05-9.12,0,0,6.53-9,8.27-9.55,0,0-12.74-1.06-20.47,2.36,0,0,6.8-7.91,22.81-4.31l8.95-7.31s-16.78-2.29-23.9.24c0,0,8.19-7,26.31-1.89L879,137s-14.31-3.08-22.83-2c0,0,9-4.85,25.69.41l7-3.13s-10.48-2.06-13.55-2.39-3.23-1.17-3.23-1.17a36.35,36.35,0,0,1,19.69,2.19S906.55,125.41,906.29,124.48Z",
    transform: "translate(-28 -124.37)",
    fill: "#ff9100",
    opacity: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M802.45,139.49s-38-2.3-33.55,24.37c0,0-.89,4.71,3.37,6.85,0,0,.07-2,3.91-1.31a17.51,17.51,0,0,0,4.13.2,8.57,8.57,0,0,0,5.05-2.09h0s10.7-4.41,14.86-21.89c0,0,3.07-3.82,2.95-4.8l-6.42,2.74s2.2,4.64.47,8.49c0,0-.21-8.32-1.44-8.12-.25,0-3.34,1.6-3.34,1.6s3.78,8.07.93,13.94c0,0,1.08-9.94-2.11-13.35l-4.52,2.64s4.42,8.33,1.42,15.13c0,0,.77-10.43-2.37-14.49l-4.09,3.19s4.14,8.22,1.62,13.86c0,0-.33-12.15-2.51-13.06,0,0-3.58,3.16-4.13,4.46,0,0,2.84,6,1.08,9.1,0,0-1.08-8.09-2-8.12,0,0-3.56,5.36-3.94,9a19.55,19.55,0,0,1,3.08-9.55,10.76,10.76,0,0,0-5.47,2.83s.56-3.78,6.35-4.12c0,0,3-4.06,3.74-4.31,0,0-5.76-.48-9.25,1.07,0,0,3.07-3.58,10.31-1.95l4-3.3s-7.58-1-10.8.11c0,0,3.7-3.16,11.89-.86l4.4-2.63s-6.46-1.4-10.32-.89c0,0,4.07-2.2,11.61.18l3.15-1.41s-4.74-.94-6.13-1.08-1.46-.53-1.46-.53a16.39,16.39,0,0,1,8.9,1S802.57,139.91,802.45,139.49Z",
    transform: "translate(-28 -124.37)",
    fill: "#ff9100",
    opacity: 0.1
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 224.19,
    cy: 637.96,
    rx: 40.21,
    ry: 6.8,
    fill: "#ff9100"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M268.82,751.21a11.64,11.64,0,0,0,3.83-5.79c.5-2.29-.48-5-2.68-5.89-2.46-.94-5.09.77-7.08,2.49s-4.28,3.69-6.88,3.32a10.5,10.5,0,0,0,3.24-9.81,4.12,4.12,0,0,0-.9-2c-1.37-1.46-3.84-.84-5.48.31-5.2,3.66-6.65,10.73-6.68,17.08-.52-2.29-.08-4.68-.09-7s-.66-5-2.65-6.23a7.91,7.91,0,0,0-4-.94c-2.33-.09-4.94.15-6.53,1.86-2,2.12-1.47,5.68.25,8s4.35,3.81,6.77,5.42a15,15,0,0,1,4.83,4.61,4.16,4.16,0,0,1,.36.83h14.66A40.77,40.77,0,0,0,268.82,751.21Z",
    transform: "translate(-28 -124.37)",
    fill: "#ff9100"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M745.36,466.38a4.55,4.55,0,0,0-2.49-3.58,4.65,4.65,0,0,0-6.16,2.6L714.5,512.13l-5,184h8l3-183.59,24.44-43.26A4.75,4.75,0,0,0,745.36,466.38Z",
    transform: "translate(-28 -124.37)",
    fill: "#3f3d56"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1103.56,737.69A144.74,144.74,0,0,1,1082.48,753a3.5,3.5,0,0,1-.39.46,6.51,6.51,0,0,1-2.75,1.38h0a164.61,164.61,0,0,1-81.08,20.82H448.44c-63-6.48-101.44-15.07-101.44-24.5,0-7.31,23.08-14.12,62.82-19.82q6.18-.9,12.89-1.74,4.13-.52,8.45-1l4.89-.57q5.44-.62,11.17-1.21l.31,0,4-.4c3.38-.35,6.83-.68,10.35-1l2.56-.23,6.53-.58q6.36-.57,13-1.09,5.51-.43,11.2-.86c38.46-2.85,82.8-5,131.05-6.39L640,715.8l4.64-.1,9.8-.22,3.93-.08,4.13-.08,2.94-.05,13.8-.22,7.09-.1h1.45q25.15-.3,51.24-.31c34.38,0,67.72.41,99.49,1.19h0q27.36.66,53.05,1.68h.16c49.38,1.94,93.58,4.8,130.16,8.35l.67.07c9.39.91,18.28,1.88,26.62,2.88,7.85.94,15.22,1.93,22.06,2.94,2.37.35,4.67.71,6.91,1.06l.57.1C1088.19,734.44,1096.51,736,1103.56,737.69Z",
    transform: "translate(-28 -124.37)",
    fill: "#ff9100",
    opacity: 0.1
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1082.48,753a3.5,3.5,0,0,1-.39.46,6.51,6.51,0,0,1-2.75,1.38h0a27.72,27.72,0,0,1-6.2,1l-.63,0a26.93,26.93,0,0,1-3.59-.12,16.67,16.67,0,0,0-2.63-.17h-.12a18.7,18.7,0,0,0-3.75.93,33.26,33.26,0,0,1-8.3,1.18l-1,0c-3.14,0-6.32-.11-9.47-.09-.51,0-1,0-1.53,0-5.4.14-10.77,1-16.17,1.09h-1.73c-5.29-.13-10.7-1.26-14.91-4.46a5.89,5.89,0,0,1-2-2.24,6.29,6.29,0,0,1-.35-3c.1-1.81.45-3.78,1.81-5a7.87,7.87,0,0,1,2.88-1.39c1.83-.59,3.67-1.16,5.5-1.73s3.92-1.18,5.89-1.76l.38-.12,1.1-.33.71-.24a11.62,11.62,0,0,0,2.46-1.12,8.15,8.15,0,0,0,2.53-2.53c.11-.18.23-.37.33-.56s0-.31-.07-.47c-.17-1.25-.3-2.53-.52-3.75a15,15,0,0,1-7.39-4.18,23.76,23.76,0,0,1-4.31-5.83c-2.49-4.68-3.77-9.91-5.63-14.88-2.85-7.56-7-14.54-11.18-21.46-3.82-6.38-7.66-12.78-12-18.81-2.89-4-6-7.81-8.86-11.82a105,105,0,0,1-17.08-37.3,49.37,49.37,0,0,0-2.07-7.58c-1.72-4.2-4.87-7.62-7.31-11.46a37.94,37.94,0,0,1-5.29-13.57c-.5-2.74-1.34-5.7-4.07-6h0l-.29.57c-5.66,11-11.47,22.2-20,31.18a33,33,0,0,0-3.73,4.29,41.24,41.24,0,0,0-2.4,4.62,30,30,0,0,1-5.31,7.77,15.15,15.15,0,0,1-2.1,1.77,11.29,11.29,0,0,1-3.29,1.65h0a9.73,9.73,0,0,1-1.42.32c0,.12.05.23.06.35s.06.26.08.39a47,47,0,0,1-1.83,23.93c-.07.24-.15.47-.24.71q-.62,1.68-1.35,3.3c-1.22,2.65-2.67,5.19-3.81,7.88-.19.46-.38.92-.55,1.38-4,10.71-3,22.67-3.52,34.18a37.65,37.65,0,0,1-.89,7.48c-.68,2.77-1.77,5.63-2.37,8.49a14.37,14.37,0,0,0-.13,6.55l-.24.09c-1.07.4-2.16.76-3.25,1.1l0,.15c.39,2.24.77,4.48,1.16,6.71.33,1.92.72,4,2.06,5.36a7.34,7.34,0,0,1,1,1c.79,1.24.09,2.88.24,4.35.22,2.08,2.14,3.85,1.84,5.92a3.9,3.9,0,0,1-2.34,2.78,6.91,6.91,0,0,1-1.54.49l-.33.07c-.6.11-1.2.17-1.8.23-7.45.74-15,1.48-22.38.22-1.46-.25-2.91-.58-4.39-.7a32.77,32.77,0,0,0-5.6.23,275,275,0,0,1-41.19.8c-3.57-.2-7.67-.78-9.56-3.83-1.57-2.53-1-5.8-.21-8.69a9.36,9.36,0,0,1,1.21-3,1.93,1.93,0,0,1,.22-.28c1.84-2.29,5.3-2.43,8.28-2.34l9.74.29a9.13,9.13,0,0,0,2.86-.22c1.58-.46,2.78-1.72,4.26-2.43,1.86-.89,4.2-1,5.54-2.52l.17-.22a12,12,0,0,0,.66-1c0-.07.09-.14.14-.21l0,0a1.88,1.88,0,0,1,.12-.18c1.23-1.62,3.38-2.16,5.13-3.19a5.28,5.28,0,0,0,.75-.53l.2-.18a20.52,20.52,0,0,1-4.86-4.89,4.91,4.91,0,0,1-1.11-1.94,2.81,2.81,0,0,1,.12-1.63,2.43,2.43,0,0,1,.16-.37l.05-.1c.68-1.34,2.08-2.55,2.85-3.92a.61.61,0,0,0,.07-.14c1.06-2,1.27-5.1-.3-6.71.8-13.17,4.42-26,5.22-39.21.32-5.23.19-10.48.43-15.73s.8-10.34,1.39-15.49c1.32-11.77,4.52-23.3,4.07-35.12a21.39,21.39,0,0,1,.14-3.3,2,2,0,0,1,0-.24,20.28,20.28,0,0,1,2.23-6.92,53.15,53.15,0,0,1,4.91-6.92c6.15-8,13.54-16,15.73-25.84,1.13-5.08,3.63-9.73,6.12-14.3,1.47-2.72,3-5.51,5.35-7.51a23.51,23.51,0,0,0,3.53-3c1.64-2.12,1.7-5.05,2.67-7.57.5-1.31,1.27-2.51,1.65-3.86,0-.14.07-.27.1-.41a27.06,27.06,0,0,0,.35-4.12c0-.4.06-.79.11-1.18,0,0,0,0,0,0a41.78,41.78,0,0,1,3.41-11.43c.21-.46.41-.93.61-1.39a42.85,42.85,0,0,1-12-10.41,24.58,24.58,0,0,1-2.91-4.39c-2.06-4.09-2.53-8.75-3.5-13.23-2.32-10.68-7.63-20.74-8.37-31.66-.22-3.33,0-6.77-1.16-9.92a19.83,19.83,0,0,0-1.13-2.48c-.18-.34-.35-.68-.53-1l-.2-.38-.51-1-.82.64A599,599,0,0,1,804,471l-1.92,1.14a7,7,0,0,0-2.54,2.08c-.08.13-.15.26-.22.39h0c-.46.95-.58,2-1,3-.9,2.29-3.21,3.75-5.57,4.43a17.2,17.2,0,0,1-12.65-1.63c-.49-.25-1-.51-1.44-.8a19.49,19.49,0,0,1-3.68,1.57c-4,1.16-8.19,1.11-12.33,1.1s-8.37,0-12.29,1.36c-2.62.89-5.16,2.36-7.88,2.5a7.37,7.37,0,0,1-.94,0,13.62,13.62,0,0,1-4.46-1.31l-.82-.37a13.4,13.4,0,0,1-1.24-.67,6.84,6.84,0,0,1-1.21-.95,4.42,4.42,0,0,1-1.12-1.91,3.17,3.17,0,0,1,0-1.59,1,1,0,0,1,.34-.6,1.08,1.08,0,0,1,.59-.15,18,18,0,0,1,3.42.29,12.32,12.32,0,0,0,2,.11l.36,0a4.34,4.34,0,0,0,3-1.7,1.87,1.87,0,0,0,.26-.48h0a2.21,2.21,0,0,0,.18-.89,1.6,1.6,0,0,0,0-.23c-.42-.19-.84-.38-1.24-.61-.21-.11-.41-.23-.61-.35l-.12-.08a6.81,6.81,0,0,1-1-.83,3.5,3.5,0,0,1-.51-.64,3.83,3.83,0,0,1-.59-1.2h0a5.37,5.37,0,0,0-2.49.07c-1.09.3-2.19.94-3.27,1.16a2.9,2.9,0,0,1-1.65-.07c-1.56-.56-2.11-2.46-2.44-4.09-.06-.31-.13-.63-.18-.95v0a5.06,5.06,0,0,1,0-1.86,6.85,6.85,0,0,1,2.63-3.43l3.28-2.75.24-.2c0-.27-.11-.54-.15-.81a5.11,5.11,0,0,1,0-1.87,6.82,6.82,0,0,1,2.63-3.42l7.26-6.11c1.36-1.14,2.84-2.34,4.61-2.46,2.63-.18,4.73,2,6.7,3.75,2.48,2.2,5.49,4,8.8,4.22a12.93,12.93,0,0,0,4.65-.64l.85-.28c-.18-.37-.36-.74-.53-1.11-.29-.61-.58-1.23-.86-1.85,4.26-.27,8.13-2.61,11.36-5.41s6-6.11,9.26-8.86c3.52-3,7.56-5.23,11.13-8.12,8.3-6.73,13.81-16.62,22.69-22.55,3.08-2.07,6.64-3.72,8.74-6.8.65-1,1.14-2,1.81-3,2.13-3,5.78-4.38,8.79-6.46s5.63-5.13,8.08-8.06c1.74-2.09,3.49-4.18,5.15-6.33,1.53-2.85,2.82-5.83,4.42-8.64a42.42,42.42,0,0,1,4.73-6.68c.41-.8.83-1.6,1.28-2.38s.78-1.31,1.2-2c.29-.45.59-.88.9-1.32-.91-1.61-1.78-3-2.19-3.61l-.2-.27a30,30,0,0,0-2.82-2.64,26.66,26.66,0,0,1-3.1-.66,29.17,29.17,0,0,1-21.46-28.17.27.27,0,0,1,0-.09,29,29,0,0,1,3.18-13.18c.42-.82.87-1.61,1.36-2.38a9,9,0,0,1-1.33-.54,5.27,5.27,0,0,1-1.86-1.53,4.43,4.43,0,0,1-.77-1.94,9.89,9.89,0,0,1,.72-4.84,23,23,0,0,1,.93-2.16.83.83,0,0,0,.07-.13c4.47-9,14-14.53,23.52-14.92,10.27-.41,20.27,4.41,28.37,11.31a38,38,0,0,1,6.44,6.77c4.23,5.88,6.14,13.4,6.7,20.85a32,32,0,0,1-.12,6.92,16.49,16.49,0,0,1-.5,2.42c-.13.47-.3.94-.48,1.41s-.29.68-.45,1l0,.05c-.15.32-.32.62-.49.92l-.09.13-.13.21c.08.19.17.39.26.58s.17.37.27.55h.12c2,.16,3.85.44,5.89.6a13.55,13.55,0,0,1,2.84.44c2,.6,3.51,2.06,5.19,3.24,4.16,2.94,9.28,4.31,13.37,7.35,6,4.48,9,11.88,12.64,18.51,4.8,8.88,12.62,16.44,16.07,25.94q2.34,6.47,4.7,12.92c3.07,8.43,6.14,16.9,10.31,24.85,5.8,11.06,13.65,21,18.3,32.62a5.2,5.2,0,0,0,2.44,2.7,212.29,212.29,0,0,1,16.85,28.19c2.57,5.19,5,10.58,5.75,16.33a39.4,39.4,0,0,1-1.25,15.26,74.09,74.09,0,0,1-2.93,8.66,14.29,14.29,0,0,0-1,3.09c0,.11,0,.22,0,.33-.2,1.92.53,3.82.73,5.74a10.62,10.62,0,0,1-.51,4.58c-.08.23-.17.46-.26.69a24.67,24.67,0,0,0-1.57,3.64,3.69,3.69,0,0,0-.08.46c-.33,2.17.53,4.36,1,6.53,1.76,7.84,1.44,16,1,24-.23,4,3,7.21,5.7,10.16,5,5.53,8.91,12,12.68,18.44a59.08,59.08,0,0,1,5.17,10.34c1.43,4.12,2,8.48,2.79,12.75,2.55,13.2,10.88,24.86,13.14,38.09a34,34,0,0,0,7.73,16.38,34.76,34.76,0,0,1,3.33,4,16.05,16.05,0,0,1,1.65,3.6,26.7,26.7,0,0,1,1.37,9.13,13.73,13.73,0,0,0,.25,4.44c.94,3.07,4.3,4.76,5.69,7.65s.43,6.59,1,9.87a10.65,10.65,0,0,0,4,6.66c-.8.7-1.64,1.34-2.5,2a10,10,0,0,1,2.07,2.18,9.81,9.81,0,0,1,1,1.77c1.32,3.07,1.36,6.72,2.44,10,.46,1.36,1.11,2.8.71,4.18a4.58,4.58,0,0,0-.34,1.24c0,.9.94,1.49,1.3,2.31A2.48,2.48,0,0,1,1082.48,753Z",
    transform: "translate(-28 -124.37)",
    fill: "url(#a2db50a1-d77e-4212-a847-6fb1a49f9674)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M870.84,363c6.12-1.65,11.57-5.1,16.91-8.51l18.61-11.85c-5.05-.4-9.41-4-12-8.36s-3.66-9.43-4.54-14.41c-8,3.12-14.93,8.41-21.39,14-2.56,2.21-8,5.55-8.79,9s4.25,6.25,6.2,8.56C866.51,352.2,872.82,362.45,870.84,363Z",
    transform: "translate(-28 -124.37)",
    fill: "#fbbebe"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M870.84,363c6.12-1.65,11.57-5.1,16.91-8.51l18.61-11.85c-5.05-.4-9.41-4-12-8.36s-3.66-9.43-4.54-14.41c-8,3.12-14.93,8.41-21.39,14-2.56,2.21-8,5.55-8.79,9s4.25,6.25,6.2,8.56C866.51,352.2,872.82,362.45,870.84,363Z",
    transform: "translate(-28 -124.37)",
    opacity: 0.1
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M769.15,460.88c-3.28,1.68-6.77,3.4-10.44,3.16-3.3-.21-6.31-2-8.79-4.19-2-1.74-4.06-3.91-6.69-3.73-1.76.12-3.24,1.31-4.6,2.44l-7.25,6.07a6.82,6.82,0,0,0-2.63,3.4,6.74,6.74,0,0,0,.17,2.82c.33,1.62.88,3.51,2.44,4.06s3.26-.63,4.91-1.08a5.78,5.78,0,0,1,5.67,1.67,3.37,3.37,0,0,1,1,2.18c0,1.81-2,3-3.84,3.09s-3.6-.51-5.42-.4a.83.83,0,0,0-.93.74,3.82,3.82,0,0,0,1.17,3.48,10.15,10.15,0,0,0,3.26,2,13.3,13.3,0,0,0,4.46,1.3c3.07.2,5.89-1.5,8.8-2.49,3.92-1.32,8.14-1.36,12.28-1.35s8.34.07,12.31-1.09,7.74-3.73,9.29-7.56a1.82,1.82,0,0,0,.17-1.16,1.92,1.92,0,0,0-.84-1c-5.58-4.13-7.84-9.15-14.12-12.12Z",
    transform: "translate(-28 -124.37)",
    fill: "#fbbebe"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M769.15,460.88c-3.28,1.68-6.77,3.4-10.44,3.16-3.3-.21-6.31-2-8.79-4.19-2-1.74-4.06-3.91-6.69-3.73-1.76.12-3.24,1.31-4.6,2.44l-7.25,6.07a6.82,6.82,0,0,0-2.63,3.4,6.74,6.74,0,0,0,.17,2.82c.33,1.62.88,3.51,2.44,4.06s3.26-.63,4.91-1.08a5.78,5.78,0,0,1,5.67,1.67,3.37,3.37,0,0,1,1,2.18c0,1.81-2,3-3.84,3.09s-3.6-.51-5.42-.4a.83.83,0,0,0-.93.74,3.82,3.82,0,0,0,1.17,3.48,10.15,10.15,0,0,0,3.26,2,13.3,13.3,0,0,0,4.46,1.3c3.07.2,5.89-1.5,8.8-2.49,3.92-1.32,8.14-1.36,12.28-1.35s8.34.07,12.31-1.09,7.74-3.73,9.29-7.56a1.82,1.82,0,0,0,.17-1.16,1.92,1.92,0,0,0-.84-1c-5.58-4.13-7.84-9.15-14.12-12.12Z",
    transform: "translate(-28 -124.37)",
    opacity: 0.1
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M886.25,354.23A12.06,12.06,0,0,0,875.67,353a22.84,22.84,0,0,0-9.11,6.07,41.9,41.9,0,0,0-6.43,8.49c-1.7,3-3,6.14-4.7,9.13-3,5.35-6.92,10.07-10.86,14.75-2.45,2.91-4.93,5.86-8.07,8s-6.65,3.45-8.78,6.42c-.67.94-1.15,2-1.81,2.95-2.09,3.06-5.64,4.7-8.73,6.75-8.86,5.9-14.37,15.72-22.65,22.41-3.57,2.88-7.6,5.14-11.11,8.08-3.27,2.73-6,6-9.26,8.8s-7.09,5.11-11.34,5.37c2.84,6.33,6.23,12.54,11.1,17.47s12.17,8.08,18.82,6.15c2.36-.68,4.67-2.12,5.57-4.4a18.82,18.82,0,0,1,1.18-3.41,7,7,0,0,1,2.53-2.07,597.79,597.79,0,0,0,76.11-52.73c6.43-5.24,12.81-9.93,19.41-15a42.43,42.43,0,0,0,6.53-5.72,21.74,21.74,0,0,0,2.64-23.95,56.81,56.81,0,0,0-6.06-8.21A72.15,72.15,0,0,0,886.25,354.23Z",
    transform: "translate(-28 -124.37)",
    fill: "#ff9100"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M886.25,354.23A12.06,12.06,0,0,0,875.67,353a22.84,22.84,0,0,0-9.11,6.07,41.9,41.9,0,0,0-6.43,8.49c-1.7,3-3,6.14-4.7,9.13-3,5.35-6.92,10.07-10.86,14.75-2.45,2.91-4.93,5.86-8.07,8s-6.65,3.45-8.78,6.42c-.67.94-1.15,2-1.81,2.95-2.09,3.06-5.64,4.7-8.73,6.75-8.86,5.9-14.37,15.72-22.65,22.41-3.57,2.88-7.6,5.14-11.11,8.08-3.27,2.73-6,6-9.26,8.8s-7.09,5.11-11.34,5.37c2.84,6.33,6.23,12.54,11.1,17.47s12.17,8.08,18.82,6.15c2.36-.68,4.67-2.12,5.57-4.4a18.82,18.82,0,0,1,1.18-3.41,7,7,0,0,1,2.53-2.07,597.79,597.79,0,0,0,76.11-52.73c6.43-5.24,12.81-9.93,19.41-15a42.43,42.43,0,0,0,6.53-5.72,21.74,21.74,0,0,0,2.64-23.95,56.81,56.81,0,0,0-6.06-8.21A72.15,72.15,0,0,0,886.25,354.23Z",
    transform: "translate(-28 -124.37)",
    opacity: 0.1
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M843.28,725.2c-1.75,1-3.9,1.56-5.13,3.18-.4.52-.67,1.13-1.1,1.63-1.33,1.56-3.69,1.63-5.54,2.52-1.48.7-2.68,2-4.25,2.41a9.22,9.22,0,0,1-2.87.22l-9.72-.29c-3.08-.09-6.69.07-8.48,2.58a9.16,9.16,0,0,0-1.22,3c-.75,2.87-1.36,6.12.21,8.64,1.88,3,6,3.61,9.55,3.81a275.64,275.64,0,0,0,41.14-.8,32.53,32.53,0,0,1,5.58-.23c1.48.12,2.93.45,4.39.7,7.37,1.25,14.91.52,22.35-.22a11.68,11.68,0,0,0,3.67-.78,3.89,3.89,0,0,0,2.33-2.77c.31-2.06-1.62-3.81-1.83-5.88-.15-1.46.55-3.09-.25-4.33a7.15,7.15,0,0,0-1-1c-1.34-1.39-1.73-3.42-2.06-5.32L887.3,722a3.16,3.16,0,0,0-.84-1.94,2.89,2.89,0,0,0-1.24-.51c-7.62-1.72-15.43-.15-23,.81a61.82,61.82,0,0,1-11.77.59c-1.7-.11-2.36-.31-3.63.8S844.87,724.27,843.28,725.2Z",
    transform: "translate(-28 -124.37)",
    fill: "#3f3d56"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1027.29,737.56a16.86,16.86,0,0,1-4.26,1.67q-5.89,1.72-11.76,3.59a7.8,7.8,0,0,0-2.87,1.38c-1.36,1.2-1.71,3.16-1.81,5a6.27,6.27,0,0,0,.35,3,6,6,0,0,0,2,2.22c4.48,3.39,10.33,4.44,15.95,4.44s11.2-.95,16.82-1.1c6.79-.18,13.76.78,20.29-1.12a17.27,17.27,0,0,1,3.86-.94,16.4,16.4,0,0,1,2.62.17,27.78,27.78,0,0,0,10.42-.95,6.41,6.41,0,0,0,2.76-1.37,2.58,2.58,0,0,0,.74-2.82c-.36-.81-1.28-1.4-1.29-2.29a4.3,4.3,0,0,1,.33-1.24c.41-1.37-.25-2.8-.71-4.15-1.29-3.86-1.08-8.3-3.39-11.65s-6.55-4.73-10.58-5.26a29.34,29.34,0,0,0-9.85.28c-3.65.78-7.06,2.41-10.64,3.45a34.8,34.8,0,0,1-12.8,1.21c-2.86-.24-1.88.21-2.85,2.61A8.51,8.51,0,0,1,1027.29,737.56Z",
    transform: "translate(-28 -124.37)",
    fill: "#3f3d56"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 839.5,
    cy: 195.76,
    r: 29,
    fill: "#fbbebe"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1077.74,727.19c-9,7.73-21.15,11.11-33,11.23-5,.05-10.19-.49-14.45-3.08-.3-1.64-.42-3.41-.72-5.05-5.17-1.08-9.18-5.29-11.68-9.95s-3.77-9.84-5.63-14.78c-2.84-7.52-7-14.45-11.16-21.33-3.82-6.34-7.65-12.7-12-18.69-2.88-4-6-7.76-8.85-11.75a104,104,0,0,1-17.05-37.06,48.46,48.46,0,0,0-2.07-7.53c-1.72-4.18-4.87-7.58-7.3-11.39a37.63,37.63,0,0,1-5.29-13.49c-.49-2.72-1.33-5.66-4.06-5.94h0c-5.74,11.15-11.59,22.48-20.27,31.55a32.71,32.71,0,0,0-3.73,4.26,41,41,0,0,0-2.4,4.6,29.64,29.64,0,0,1-5.3,7.72,12.36,12.36,0,0,1-6.82,3.72,46.64,46.64,0,0,1-3.28,28.5c-1.21,2.64-2.66,5.16-3.8,7.83-4.66,11-3.58,23.41-4.07,35.34a37.15,37.15,0,0,1-.88,7.43c-1.21,4.88-3.71,10.07-2.5,14.95-12.54,4.79-26.47,4.49-39.75,2.47a19.15,19.15,0,0,1-7.41-2.25,20.39,20.39,0,0,1-4.86-4.86,4.87,4.87,0,0,1-1.11-1.93c-.52-2.28,2-4,3.17-6s1.38-5.17-.23-6.81c.8-13.09,4.42-25.87,5.22-39,.32-5.2.19-10.42.43-15.63s.8-10.28,1.38-15.4c1.32-11.69,4.52-23.15,4.07-34.9a20.3,20.3,0,0,1,2.41-10.39,52.4,52.4,0,0,1,4.9-6.88c6.14-7.93,13.52-15.88,15.71-25.67,1.13-5.05,3.63-9.67,6.11-14.21,1.47-2.71,3-5.48,5.34-7.47a23.39,23.39,0,0,0,3.53-3c1.64-2.11,1.7-5,2.67-7.52.5-1.3,1.27-2.5,1.64-3.84a21.88,21.88,0,0,0,.45-4.5c.32-4.84,2.18-9.52,4.14-13.95a42.73,42.73,0,0,1-12-10.34,25.3,25.3,0,0,1-2.9-4.37c-2.06-4.06-2.53-8.69-3.5-13.14-2.31-10.62-7.62-20.61-8.36-31.46-.22-3.31,0-6.73-1.15-9.86a31,31,0,0,0-1.86-3.85,15.75,15.75,0,0,1-1.58-3.88c-.64-2.95.24-6,0-9-.24-2.65-1.37-5.13-1.93-7.72a36.66,36.66,0,0,1-.29-10.2c.25-4,1.12-8.13.78-12.08A46.67,46.67,0,0,1,879,350.7l.23-.23c1.91-2,4-3.77,5.72-5.89,2.34-2.84,4-6.18,6.47-8.94,1.08-1.23,2.3-2.33,3.37-3.57a29.64,29.64,0,0,1,3.25-3.64,5,5,0,0,1,4.52-1.21,12.53,12.53,0,0,0,1.38,4.26c2.08.16,3.93.45,6,.61a13.55,13.55,0,0,1,2.84.44c1.95.59,3.51,2,5.18,3.21,4.16,2.93,9.27,4.29,13.36,7.31,6,4.45,9,11.8,12.62,18.39,4.79,8.83,12.6,16.34,16,25.78l4.69,12.84c3.07,8.38,6.14,16.79,10.3,24.69,5.79,11,13.63,20.91,18.28,32.42a5.22,5.22,0,0,0,2.43,2.68,209.12,209.12,0,0,1,16.83,28c2.57,5.16,5,10.52,5.74,16.23,1.09,8.07-1.11,16.23-4.17,23.77a12.39,12.39,0,0,0-1,3.4c-.2,1.91.53,3.79.73,5.7a10.55,10.55,0,0,1-.77,5.24,24,24,0,0,0-1.57,3.62c-.54,2.3.42,4.64.94,6.94,1.76,7.79,1.44,15.86,1,23.84-.23,4,3,7.17,5.69,10.1,5,5.49,8.9,11.91,12.67,18.32a59.19,59.19,0,0,1,5.16,10.28c1.43,4.09,2,8.42,2.79,12.67,2.54,13.11,10.86,24.7,13.12,37.85a33.63,33.63,0,0,0,7.72,16.27,35.41,35.41,0,0,1,3.33,4,16.11,16.11,0,0,1,1.64,3.58,26.36,26.36,0,0,1,1.37,9.07,13.55,13.55,0,0,0,.25,4.41c.94,3.05,4.3,4.73,5.68,7.6s.43,6.55,1,9.81A10.56,10.56,0,0,0,1077.74,727.19Z",
    transform: "translate(-28 -124.37)",
    fill: "#ff9100"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M775.15,451.88c-3.28,1.68-6.77,3.4-10.44,3.16-3.3-.21-6.31-2-8.79-4.19-2-1.74-4.06-3.91-6.69-3.73-1.76.12-3.24,1.31-4.6,2.44l-7.25,6.07a6.82,6.82,0,0,0-2.63,3.4,6.74,6.74,0,0,0,.17,2.82c.33,1.62.88,3.51,2.44,4.06s3.26-.63,4.91-1.08a5.78,5.78,0,0,1,5.67,1.67,3.37,3.37,0,0,1,1,2.18c0,1.81-2,3-3.84,3.09s-3.6-.51-5.42-.4a.83.83,0,0,0-.93.74,3.82,3.82,0,0,0,1.17,3.48,10.15,10.15,0,0,0,3.26,2,13.3,13.3,0,0,0,4.46,1.3c3.07.2,5.89-1.5,8.8-2.49,3.92-1.32,8.14-1.36,12.28-1.35s8.34.07,12.31-1.09,7.74-3.73,9.29-7.56a1.82,1.82,0,0,0,.17-1.16,1.92,1.92,0,0,0-.84-1c-5.58-4.13-7.84-9.15-14.12-12.12Z",
    transform: "translate(-28 -124.37)",
    fill: "#fbbebe"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M853.39,302.31c-1.73.28-3.2,1.45-4.84,2.1a8.34,8.34,0,0,1-6.84-.36,5.28,5.28,0,0,1-1.87-1.52c-1.34-1.86-.87-4.56-.05-6.74,3.88-10.31,14.24-16.69,24.5-17.1s20.24,4.38,28.33,11.23a38.71,38.71,0,0,1,6.43,6.73c4.22,5.85,6.13,13.32,6.69,20.72a27,27,0,0,1-.61,9.28,11.28,11.28,0,0,1-5.26,7.09c-2.86,1.46-6.29,1-9.18-.4s-5.37-3.61-7.85-5.72a11.66,11.66,0,0,0-3.91-2.49,4,4,0,0,0-4.23,1c-1.34,1.61-1,4.25-2.22,6s-3.76,2-5.9,2-4.31-.18-5.59-1.88c-1.17-1.54-1-3.79-.56-5.73s1.19-3.86,1-5.85c-.41-4-3.91-6.46-5-10.14-.71-2.41.85-3.43.69-5.61C857,303,854.94,302.06,853.39,302.31Z",
    transform: "translate(-28 -124.37)",
    fill: "#3f3d56"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M944.5,578.13l0,.25h0c-5.74,11.15-11.59,22.48-20.27,31.55a32.71,32.71,0,0,0-3.73,4.26,41,41,0,0,0-2.4,4.6,29.64,29.64,0,0,1-5.3,7.72l-7.24,3.62,23-120Z",
    transform: "translate(-28 -124.37)",
    opacity: 0.1
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M911.07,396.51a42.43,42.43,0,0,1-6.53,5.72c-6.6,5-13,9.72-19.41,15q-7.75,6.31-15.72,12.36a15.75,15.75,0,0,1-1.58-3.88c-.64-2.95.24-6,0-9-.24-2.65-1.37-5.13-1.93-7.72a36.66,36.66,0,0,1-.29-10.2c.25-4,1.12-8.13.78-12.08A46.67,46.67,0,0,1,879,350.7l.23-.23a17.56,17.56,0,0,1,3.4-1.52,12.06,12.06,0,0,1,10.58,1.28,72.15,72.15,0,0,1,14.4,14.12,56.81,56.81,0,0,1,6.06,8.21A21.74,21.74,0,0,1,911.07,396.51Z",
    transform: "translate(-28 -124.37)",
    opacity: 0.1
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M892.25,345.23A12.06,12.06,0,0,0,881.67,344a22.84,22.84,0,0,0-9.11,6.07,41.9,41.9,0,0,0-6.43,8.49c-1.7,3-3,6.14-4.7,9.13-3,5.35-6.92,10.07-10.86,14.75-2.45,2.91-4.93,5.86-8.07,8s-6.65,3.45-8.78,6.42c-.67.94-1.15,2-1.81,2.95-2.09,3.06-5.64,4.7-8.73,6.75-8.86,5.9-14.37,15.72-22.65,22.41-3.57,2.88-7.6,5.14-11.11,8.08-3.27,2.73-6,6-9.26,8.8s-7.09,5.11-11.34,5.37c2.84,6.33,6.23,12.54,11.1,17.47s12.17,8.08,18.82,6.15c2.36-.68,4.67-2.12,5.57-4.4a18.82,18.82,0,0,1,1.18-3.41,7,7,0,0,1,2.53-2.07,597.79,597.79,0,0,0,76.11-52.73c6.43-5.24,12.81-9.93,19.41-15a42.43,42.43,0,0,0,6.53-5.72,21.74,21.74,0,0,0,2.64-23.95,56.81,56.81,0,0,0-6.06-8.21A72.15,72.15,0,0,0,892.25,345.23Z",
    transform: "translate(-28 -124.37)",
    fill: "#ff9100"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M868.58,330.1c-2,0-4.31-.18-5.59-1.88-1.16-1.54-1-3.79-.56-5.73s1.19-3.86,1-5.85c-.41-4-3.91-6.46-5-10.14-.71-2.41.85-3.43.69-5.61-.14-1.89-2.19-2.83-3.74-2.58-1.73.28-3.2,1.45-4.84,2.1a8.34,8.34,0,0,1-6.84-.36,5.28,5.28,0,0,1-1.87-1.52c-1.34-1.86-.87-4.56-.05-6.74,0-.08.07-.15.1-.23a24.16,24.16,0,0,0-2.1,4.23c-.82,2.18-1.29,4.88.05,6.74a5.28,5.28,0,0,0,1.87,1.52,8.34,8.34,0,0,0,6.84.36c1.64-.65,3.11-1.82,4.84-2.1,1.55-.25,3.6.69,3.74,2.58.16,2.18-1.4,3.2-.69,5.61,1.07,3.68,4.57,6.18,5,10.14.2,2-.53,3.92-1,5.85s-.6,4.19.56,5.73c1.28,1.7,3.57,1.86,5.59,1.88s4.62-.12,5.9-2a8.43,8.43,0,0,0,1.07-3.07C872.19,330,870.29,330.12,868.58,330.1Z",
    transform: "translate(-28 -124.37)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M901.87,329.74c-2.86,1.46-6.29,1-9.18-.4s-5.37-3.61-7.85-5.72a11.66,11.66,0,0,0-3.91-2.49,4,4,0,0,0-4.23,1,7.58,7.58,0,0,0-1.25,3.36,4.23,4.23,0,0,1,3.48-.37,11.66,11.66,0,0,1,3.91,2.49c2.48,2.11,5,4.33,7.85,5.72s6.32,1.86,9.18.4A11.13,11.13,0,0,0,905,327,9.25,9.25,0,0,1,901.87,329.74Z",
    transform: "translate(-28 -124.37)"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 625,
    cy: 605.26,
    r: 30,
    fill: "#3f3d56"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 625,
    cy: 605.26,
    r: 30,
    opacity: 0.1
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 625,
    cy: 605.26,
    r: 19,
    fill: "#65617d"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 625,
    cy: 605.26,
    r: 19,
    opacity: 0.1
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M630,682.63l19.68,44.5a3.82,3.82,0,0,0,6.93.14L680,679.63Z",
    transform: "translate(-28 -124.37)",
    fill: "#3f3d56"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M630,682.63l19.68,44.5a3.82,3.82,0,0,0,6.93.14L680,679.63Z",
    transform: "translate(-28 -124.37)",
    opacity: 0.1
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 438,
    cy: 605.26,
    r: 30,
    fill: "#3f3d56"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 438,
    cy: 605.26,
    r: 30,
    opacity: 0.1
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 438,
    cy: 605.26,
    r: 19,
    fill: "#65617d"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 438,
    cy: 605.26,
    r: 19,
    opacity: 0.1
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M443,682.63l19.68,44.5a3.82,3.82,0,0,0,6.93.14L493,679.63Z",
    transform: "translate(-28 -124.37)",
    fill: "#3f3d56"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M443,682.63l19.68,44.5a3.82,3.82,0,0,0,6.93.14L493,679.63Z",
    transform: "translate(-28 -124.37)",
    opacity: 0.1
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M750.36,468.38a4.55,4.55,0,0,0-2.49-3.58,4.65,4.65,0,0,0-6.16,2.6L724.5,510.13l-5,192h8l3-191.59,19.44-39.26A4.75,4.75,0,0,0,750.36,468.38Z",
    transform: "translate(-28 -124.37)",
    fill: "#3f3d56"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "368.5 562.76 395.5 545.76 687 543.26 694.5 562.76 368.5 562.76",
    fill: "#ff9100"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "368.5 580.76 368.5 562.76 699.78 559.56 699.46 571.76 374.5 571.76 374.5 580.76 368.5 580.76",
    fill: "#3f3d56"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 410.5,
    cy: 615.76,
    r: 30,
    fill: "#3f3d56"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 410.5,
    cy: 615.76,
    r: 19,
    fill: "#65617d"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M415.5,693.13l19.68,44.5a3.82,3.82,0,0,0,6.93.14l23.39-47.64Z",
    transform: "translate(-28 -124.37)",
    fill: "#3f3d56"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 643.5,
    cy: 615.76,
    r: 30,
    fill: "#3f3d56"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 643.5,
    cy: 615.76,
    r: 19,
    fill: "#65617d"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M648.5,693.13l19.68,44.5a3.82,3.82,0,0,0,6.93.14l23.39-47.64Z",
    transform: "translate(-28 -124.37)",
    fill: "#3f3d56"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 406,
    y: 484.26,
    width: 125,
    height: 69,
    fill: "#65617d"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 450,
    y: 496.26,
    width: 38,
    height: 8,
    opacity: 0.1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 454.75,
    y: 497.26,
    width: 28.5,
    height: 6,
    opacity: 0.1
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 533,
    y: 484.26,
    width: 125,
    height: 69,
    fill: "#65617d"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 577,
    y: 496.26,
    width: 38,
    height: 8,
    opacity: 0.1
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 581.75,
    y: 497.26,
    width: 28.5,
    height: 6,
    opacity: 0.1
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 406,
    y: 413.26,
    width: 125,
    height: 69,
    fill: "#65617d"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 450,
    y: 425.26,
    width: 38,
    height: 8,
    opacity: 0.1
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 454.75,
    y: 426.26,
    width: 28.5,
    height: 6,
    opacity: 0.1
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 533,
    y: 413.26,
    width: 125,
    height: 69,
    fill: "#65617d"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 577,
    y: 425.26,
    width: 38,
    height: 8,
    opacity: 0.1
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 581.75,
    y: 426.26,
    width: 28.5,
    height: 6,
    opacity: 0.1
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 406,
    y: 341.26,
    width: 125,
    height: 69,
    fill: "#65617d"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 450,
    y: 353.26,
    width: 38,
    height: 8,
    opacity: 0.1
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 454.75,
    y: 354.26,
    width: 28.5,
    height: 6,
    opacity: 0.1
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 533,
    y: 341.26,
    width: 125,
    height: 69,
    fill: "#65617d"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 577,
    y: 353.26,
    width: 38,
    height: 8,
    opacity: 0.1
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 581.75,
    y: 354.26,
    width: 28.5,
    height: 6,
    opacity: 0.1
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 533,
    y: 269.26,
    width: 125,
    height: 69,
    fill: "#65617d"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 577,
    y: 281.26,
    width: 38,
    height: 8,
    opacity: 0.1
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 581.75,
    y: 282.26,
    width: 28.5,
    height: 6,
    opacity: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShippingsProcessing);
export default __webpack_public_path__ + "static/media/shippingsProcessing.77eb63d762fea6d6c406cf95f38eef1d.svg";
export { ForwardRef as ReactComponent };